import { SxProps, Theme } from "@mui/material/styles";

const styles: SxProps<Theme> = [
  {
    "&.container": {
      maxWidth: 1080,
      margin: "auto",
    },
    "& .firstList": {
      "& li": {
        listStyle: "inside",
        listStyleType: "decimal",
        marginBottom: "12px",
      },
    },
    "& .secondList": {
      "& li": {
        listStyle: "inside",
        listStyleType: "-",
        marginTop: 1,
        marginBottom: 1,
        paddingLeft: "24px",
      },
    },
  },
];

export default styles;
